import { jsx as o } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import t from "@silversea-ssc/design-system-icons";
import g from "@silversea-ssc/design-system-icons/dist/svg-sprite.svg";
import { c as d } from "../clsx-OuTLNxxd.js";
const p = "Icon-module_wrapper__99KmA",
  u = "Icon-module_icon-container__F6SCF",
  z = "Icon-module_padding-inline__0Lfkp",
  I = "Icon-module_padding-inline-right__sEwg7",
  X = "Icon-module_padding-small__r0NHd",
  x = "Icon-module_padding-medium__-idDY",
  f = "Icon-module_padding-large__BlBNr",
  h = "Icon-module_size-0_5x__yiidA",
  w = "Icon-module_size-1x__HSP63",
  C = "Icon-module_size-1_5x__9i0nD",
  v = "Icon-module_size-2x__EmrML",
  L = "Icon-module_size-2_5x__1vgnl",
  N = "Icon-module_size-3x__3oJiX",
  S = "Icon-module_size-4x__7hCaO",
  n = {
    wrapper: p,
    iconContainer: u,
    paddingInline: z,
    paddingInlineRight: I,
    paddingSmall: X,
    paddingMedium: x,
    paddingLarge: f,
    size05X: h,
    size1X: w,
    size15X: C,
    size2X: v,
    size25X: L,
    size3X: N,
    size4X: S
  },
  M = /* @__PURE__ */Object.keys(t),
  R = (_ref, _) => {
    let {
      name: s,
      className: l,
      wrapperClassName: r,
      size: i = "1x",
      padding: e = "medium",
      ariaHidden: c,
      strokeWidth: a = 0
    } = _ref;
    return M.includes(s) ? /* @__PURE__ */o("span", {
      className: d(n.wrapper, r),
      ref: _,
      children: /* @__PURE__ */o("svg", {
        "aria-hidden": c,
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: a,
        xmlns: "http://www.w3.org/2000/svg",
        className: d({
          [n.iconContainer]: !0,
          [n.paddingInline]: e == "inline",
          [n.paddingInlineRight]: e == "inline-right",
          [n.paddingSmall]: e == "small",
          [n.paddingMedium]: e == "medium",
          [n.paddingLarge]: e == "large",
          [n.size05X]: i == "0.5x",
          [n.size1X]: i == "1x",
          [n.size15X]: i == "1.5x",
          [n.size2X]: i == "2x",
          [n.size25X]: i == "2.5x",
          [n.size3X]: i == "3x",
          [n.size4X]: i == "4x"
        }, l),
        children: /* @__PURE__ */o("use", {
          href: "".concat(g, "#svg--").concat(s)
        })
      })
    }) : null;
  },
  A = /* @__PURE__ */m(R);
export { A as Icon, R as IconBase };